import { useEffect } from 'react'

export function useScrollReveal() {
  useEffect(() => {
    const revealAll = () => {
      const elements = document.querySelectorAll('.r')

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in')
              observer.unobserve(entry.target)
            }
          })
        },
        { threshold: 0.05, rootMargin: '0px 0px -6% 0px' },
      )

      elements.forEach((el) => observer.observe(el))

      // Fallback: force-show anything already in viewport
      setTimeout(() => {
        elements.forEach((el) => {
          const rect = el.getBoundingClientRect()
          if (rect.top < window.innerHeight) {
            el.classList.add('in')
          }
        })
      }, 60)

      return observer
    }

    const observer = revealAll()
    return () => observer.disconnect()
  }, [])
}

// Keep backward compat
export function useRevealOnScroll(selector = '.r') {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in')
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.05, rootMargin: '0px 0px -6% 0px' },
    )

    const elements = document.querySelectorAll(selector)
    elements.forEach((el) => observer.observe(el))

    return () => observer.disconnect()
  }, [selector])
}
